import { client } from './auth';

/** 게시판 조회 */
export async function getArticleList(boardNo: number, page: number) {
  return await client.get(`/boards/${boardNo}/articles?pageNumber=${page}`);
}

/** 게시글 상세 조회 */
export async function getArticleDetail(boardNo: number, articleNo: string) {
  return await client.get(`/boards/${boardNo}/articles/${articleNo}`);
}

//게시판 설정 조회
export async function getBoardConfiguration() {
  return await client.get(`/boards/configurations`);
}
